<template>
  <div class="transaction-container" :class="{ selected: isSelected && isTransactionEditable }">
    <div @click="canEditCategory && toggleActions()">
      <transaction-row :out-of-date=outOfDate :transaction="transaction"
                       :can-edit-category="canEditCategory" :category-id="categoryId" :isSelected="isSelected"/>
    </div>

    <collapse-transition>
      <actions :actions="actions" :category-name="categoryName" v-show="isSelected && isTransactionEditable"/>
    </collapse-transition>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BaseUI from 'base-ui';
import EventBus from '@/event-bus/event-bus';
import transactionUtils from '../../../../../../../../../utils/transaction';
import TransactionRow from './TransactionRow.vue';
import Actions from '../../../../../../../../../base-components/Actions.vue';
import Segment from '../../../../../../../../../Segment';
import ChangeTransactionCategoryPopup from '../../../current-month/components/cashflow-edit/edit-transaction/ChangeTransactionCategoryPopup.vue';
import cashflowViewConsts from '../../../../../../../../../constants/cashflow-view';
import AddTransactionComment from '../../../current-month/components/cashflow-edit/edit-transaction/AddTransactionComment.vue';
import SplitTransactionPopup
  from '../../../current-month/components/cashflow-edit/edit-transaction/SplitTransactionPopup.vue';

export default {
  name: 'Transaction',
  props: {
    transaction: {
      type: Object,
      required: true,
    },
    canEditCategory: {
      type: Boolean,
      required: true,
    },
    categoryName: {
      type: String,
      required: false,
    },
    categoryId: {
      type: String,
      default: '',
    },
    outOfDate: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      required: false,
    },
  },
  components: {
    CollapseTransition: BaseUI.CollapseTransition,
    TransactionRow,
    Actions,
  },
  created() {
    EventBus.$on('expand-to-edit', ({ type }) => {
      if (type === this.type) {
        this.expandActionsOf(`${this.transaction.transactionId}${this.categoryName}${this.categoryId}`);
      }
    });
  },
  computed: {
    ...mapState('cashflowView', ['actionsExpandedFor', 'isSplitTransactionsEnabled']),
    incomeOrExpense() {
      return transactionUtils.incomeOrExpense(this.transaction);
    },
    isExcludedCategory() {
      return this.categoryName === cashflowViewConsts.CATEGORY_NAMES.EXCLUDED_INCOME
          || this.categoryName === cashflowViewConsts.CATEGORY_NAMES.EXCLUDED_EXPENSE;
    },
    actionsMapping() {
      return {
        editCategory: {
          text: `להעביר את ה${this.incomeOrExpense} למקום אחר `,
          icon: 'edits-move',
          onClick: () => this.openEditCategory(ChangeTransactionCategoryPopup),
        },
        moveExcludedBack: {
          text: 'להעביר בחזרה לתזרים',
          icon: 'edits-exclude',
          onClick: () => this.openEditCategory(ChangeTransactionCategoryPopup),
        },
        addComment: {
          text: this.transaction.customerComment ? 'עריכת הערה' : 'הוספת הערה',
          icon: 'comment',
          onClick: () => this.openEditCategory(AddTransactionComment),
        },
        splitTransaction: {
          text: this.transaction.splitFrom ? 'ערוך פיצול' : 'פצל הוצאה',
          icon: 'comment',
          onClick: () => this.openEditCategory(SplitTransactionPopup),
        },
      };
    },
    actions() {
      return [
        this.isExcludedCategory ? this.actionsMapping.moveExcludedBack : this.actionsMapping.editCategory,
        this.actionsMapping.addComment,
        ...this.isSplitTransactionsEnabled ? [this.actionsMapping.splitTransaction] : [],
      ];
    },
    isTransactionEditable() {
      return this.canEditCategory;
    },
    isSelected() {
      return this.actionsExpandedFor === `${this.transaction.transactionId}${this.categoryName}${this.categoryId}`;
    },
  },
  methods: {
    ...mapActions('editTransaction', ['startEditingTransaction']),
    ...mapActions('cashflowView', ['expandActionsOf']),
    ...mapActions('modalRootStore', ['openModal']),
    toggleActions() {
      if (this.isSelected) {
        this.expandActionsOf(null);
      } else {
        this.expandActionsOf(`${this.transaction.transactionId}${this.categoryName}${this.categoryId}`);
      }
    },
    openEditCategory(component) {
      Segment.trackUserInteraction('EditTransactionClicked', {
        businessName: this.transaction.businessName,
        transactionId: this.transaction.transactionId,
      });
      this.startEditingTransaction({
        transaction: this.transaction,
        categoryName: this.categoryName,
        categoryId: this.categoryId,
      });
      this.openModal({
        component,
      });
    },
  },
};

</script>

<style scoped lang="scss">
    @import '../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .transaction-container {
    transition: background-color 0.3s;
    background-color: $riseup_gray_0;
    &.selected {
      background-color: $riseup_gray_-1;
    }
    border-bottom: 1px solid $riseup_gray_0;
    &:first-of-type {
      box-shadow: inset 0 2px 3px 0 rgba(155, 155, 155, 0.51);
    }
    &:last-of-type {
      border-bottom: none;
    }
  }

</style>
